import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { OrderStatus, useGetCurrentOrderQuery } from 'src/Redux/artistOrderApi'
import { findOrderCampaign } from 'src/Redux/artistOrderApi/campaignPayment'
import { getCampaignDetailsRoute } from 'src/Redux/artistOrderApi/campaignPaymentRoutes'
import { ScheduleSteps } from 'src/Types/ui'

import { useCustomSearchParams } from './useCustomSearchParams'

export const useRedirectFailedCheckout = (): void => {
  const navigate = useNavigate()
  const { search } = useCustomSearchParams()
  const { data: currentOrder } = useGetCurrentOrderQuery(void 0)

  const isCheckoutStep = search.get('step') === ScheduleSteps.CHECKOUT
  const isPaymentReturn = search.has('paymentStatus')
  const failedCampaign =
    currentOrder?.status === OrderStatus.CheckoutFailed
      ? findOrderCampaign(currentOrder.items)
      : null

  const failedPlatform = failedCampaign?.platform
  const failedCampaignId = failedCampaign?.campaignId

  useEffect(() => {
    if (
      !isCheckoutStep ||
      isPaymentReturn ||
      !failedPlatform ||
      failedCampaignId === void 0
    ) {
      return
    }

    navigate(getCampaignDetailsRoute(failedPlatform, failedCampaignId), {
      replace: true,
    })
  }, [
    failedCampaignId,
    failedPlatform,
    isCheckoutStep,
    isPaymentReturn,
    navigate,
  ])
}
